import { createBookingDevEnvironment, DEV_ENVIRONMENT_COOKIE_KEY } from '@booking/utils/devEnvironment'

export default defineNuxtPlugin({
  name: 'dev-environment',
  enforce: 'pre',
  setup() {
    const environment = import.meta.dev
      ? createBookingDevEnvironment(useRuntimeConfig(), useCookie(DEV_ENVIRONMENT_COOKIE_KEY).value)
      : undefined
    return { provide: { devEnvironment: environment } }
  },
})
